import React, { useMemo, useState, useContext, useEffect } from 'react'
import List from './List';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { Filters } from '../../Dashboard/views/components/RentalDashboard';
import FleetManagerCarKPI from './FleetManagerCarKPI';
import RentalManagerCarKPI from './RentalManagerCarKPI';
import useFiltersFromLocation from 'src/mtska-frontend-app-scaffolding/hooks/useFiltersFromLocation';

const Default = () => {
    const { appConfiguration, userCapabilities } = useContext(AppContext);
    const [filtersFromLocation, setFiltersFromLocation] = useFiltersFromLocation();
    const [filtersFromTable, setFiltersFromTable] = useState();
    const [filters, setFilters] = useState();

    const mergeFiltersFromTable = (items) => {
        setFiltersFromTable(items);
    }

    useEffect(() => {
        const timeout = setTimeout(() => {
            console.info(filtersFromLocation, filtersFromTable);

            setFilters({
                items: [
                    ...(filtersFromLocation?.items ?? []),
                    ...(filtersFromTable ? filtersFromTable.map(({ id, fromInput, ...rest }) => rest) : [])
                ]
            });
        }, 500); // debounce di 500ms

        return () => clearTimeout(timeout);
    }, [filtersFromLocation, filtersFromTable]);


    return useMemo(() => <>
        {
            appConfiguration.dashboard.view == 'fleetmanager' &&
            <FleetManagerCarKPI filters={filtersFromLocation} setFilters={setFiltersFromLocation} userCapabilities={userCapabilities} />
        }
        {
            appConfiguration.dashboard.view == 'ConsecutionSales' &&
            <>
                <RentalManagerCarKPI filters={filters} setFilters={setFiltersFromLocation} userCapabilities={userCapabilities} />
                <Filters filters={filters} setFilters={setFiltersFromLocation} />
            </>
        }
        <List filters={filters} setFilters={mergeFiltersFromTable} />
    </>, [filters])

}

export default Default;


